var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.176,
    height: 38.144,
    viewBox: "0 0 35.176 38.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building",
    transform: "translate(-19.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11763",
    "data-name": "Path 11763",
    d: "M52.741,35.908V8.5h-3.55V35.908H46.955V0L28.04,5.3v7.6h8.08V35.908H33.884V15.137H24.5V35.908H19.912v2.236H55.088V35.908ZM40.371,23.164v-4.5h2.236v4.5Zm2.236,3.716v4.5H40.371v-4.5ZM40.371,14.952v-4.5h2.236v4.5Zm-12.3,3.716h2.236v4.5H28.072Zm0,8.212h2.236v4.5H28.072Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/building_icon.cec74f117a6d0f3db6b00bee00c21d3d.svg";
export { ForwardRef as ReactComponent };